"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var img = new Image();
var canvas = document.createElement('canvas');

var compressImg = function compressImg(base64Str, maxSize) {
  return new Promise(function (resolve, reject) {
    if (!base64Str.indexOf('base64,')) {
      reject('目前只支持file类型和base64格式');
      return;
    }

    var size = imageSize(base64Str);
    console.log('压缩前', formatSize(size));

    if (size <= maxSize) {
      var blob = dataURLtoBlob(base64Str);
      resolve(blob);
      return;
    }

    compressLoop(function (blob) {
      if (blob) resolve(blob);
    }, function (err) {
      resolve(err);
    }, maxSize, base64Str);
  });
};

var compressLoop = function compressLoop(callback, failCallback, maxSize, base64Str) {
  var ratioQuality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.98;
  var ratioSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
  img.src = base64Str;
  var ctx = canvas.getContext('2d');
  img.addEventListener('load', function () {
    canvas.width = img.width / ratioSize;
    canvas.height = img.height / ratioSize;
    ctx.drawImage(img, 0, 0, img.width / ratioSize, img.height / ratioSize);
    var newImgBase64 = canvas.toDataURL('image/jpeg', ratioQuality);
    var size = imageSize(newImgBase64);
    console.log('压缩后', formatSize(size), ratioQuality);

    if (size > maxSize) {
      if (ratioQuality <= 0.5) {
        compressLoop(callback, failCallback, maxSize, newImgBase64, ratioQuality, ratioSize * 1.5);
        return;
      } else {
        compressLoop(callback, failCallback, maxSize, newImgBase64, ratioQuality - 0.15);
        return;
      }
    } else if (size <= 0) {
      compressLoop(callback, failCallback, maxSize, newImgBase64, ratioQuality, ratioSize * 1.5);
      failCallback('failed');
      return;
    }

    console.log('newImgBase64', newImgBase64);
    callback(dataURLtoBlob(newImgBase64));
  });
};

var fileCompress = function fileCompress(file, maxSize) {
  return new Promise(function (resolve, reject) {
    if (Object.prototype.toString.call(file) === '[object File]') {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', function () {
        var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(e) {
          var base64Str, blobData;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  base64Str = e.target.result;
                  _context.next = 3;
                  return compressImg(base64Str, maxSize);

                case 3:
                  blobData = _context.sent;

                  if (blobData === 'failed') {
                    reject('failed');
                  } else {
                    resolve(blobData);
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    } else {
      reject('文件格式有误');
    }
  });
};

var dataURLtoBlob = function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(',');
  console.log('arr', arr);
  var mime = arr[0].match(/:(.*?);/) ? arr[0].match(/:(.*?);/)[1] : 'image/jpeg';
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], {
    type: mime
  });
};

var imageSize = function imageSize(base64Str) {
  var indexBase64 = base64Str.indexOf('base64,');
  if (indexBase64 < 0) return -1;
  var str = base64Str.substr(indexBase64 + 6);
  return (str.length * 0.75).toFixed(2);
};

var formatSize = function formatSize(sizeNum) {
  if (typeof sizeNum === 'string') {
    sizeNum = Number(sizeNum);
  }

  if (typeof sizeNum !== 'number') {
    console.log('长度单位类型有误');
    return;
  }

  if (sizeNum < 1024 * 1024) {
    return "".concat(Math.floor(sizeNum / 1024), "KB");
  } else if (sizeNum >= 1024 * 1024 && sizeNum < 1024 * 1024 * 1024) {
    return "".concat(Math.floor(sizeNum / (1024 * 1024)), "MB");
  } else if (sizeNum >= 1024 * 1024 * 1024 && sizeNum < 1024 * 1024 * 1024 * 1024) {
    return "".concat(Math.floor(sizeNum / (1024 * 1024 * 1024)), "GB");
  }
};

var _default = {
  compressImg: compressImg,
  fileCompress: fileCompress,
  compressLoop: compressLoop
};
exports["default"] = _default;